/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import closeIcon from '@svb/svbbranding/dist/assets/icons/Close.svg';
import {
  SVBSearchModal,
  SVBSearchResult,
  SVBSearchEmptyResult,
  SVBSearchExplore,
  SVBSearchUIBar,
  SVBSearchFilter,
  SVBRecentSearch,
} from '@svb/portal-ui-react-components/dist/react-molecule/SVBSearch';
import Loading from '@svb/api-loading-component/dist/components/index';
import * as Session from '@svb/api-session-component/dist/components/session';
// import searchMockService from "./helpers/service";
import {
  searchBuildResultArray,
  addToLocalStorage,
  removeFromLocalStorage,
} from './searchHelpers/index';
// import { SVBSearchUIBar } from "../../extra/SVBSearch";
// import SVBSearchResult from "./SVBSearchResult";
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getUISearchResult } from '../../helpers/browseSearchHandler';
import { useSearchJsonData } from './searchHelpers/service/SearchDataProvider';
import { getFileContent, useConditionalRecaptcha } from '../../helpers/utilityFunctions';
import '@svb/svbbranding/components/svb-ui-branding-search-component/dist/css/svb-base.css';

export default function SVBSearchUI(props) {
  const { show, hideSearchModal, title } = props;
  const { apisDataFromJson, faqsDataFromJson, solutionsDataFromJson, resourcessDataFromJson } =
    useSearchJsonData(); //gets json datas for different contents from context props
  const [loading, setLoading] = useState(true);
  const [popularSearch, setPopularSearch] = useState([]);
  const [searchHistory, setsearchHistory] = useState([]); // used for updating the recent search data
  const [initialRecentData, setInitialRecentData] = useState([]); //to use initial recent search history for recent search component
  const [searchTerm, setsearchTerm] = useState('');
  const [userTyped, setuserTyped] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showPopSearch, setshowPopSearch] = useState(true);
  const [selectedFilterValue, setselectedFilterValue] = useState('');
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [formErrorMessages, setformErrorMessages] = useState([]);
  const [formError, setFormError] = useState(false);
  const [submittedTerm, setsubmittedTerm] = useState('');
  const [loadingRes, setloadingRes] = useState(true);
  const [resultCount, setresultCount] = useState(0);
  const [result, setResult] = useState([]);
  const [renderResult, setRenderResult] = useState([]);
  const [fetchPop, setFetchPop] = useState(false);
  //get popular search sample file
  const getSearchPopularContent = getFileContent(
    `${process.env.REACT_APP_CONTENT_SERVER}/portal-content?resourcePath=pages/search&resourceName=search-popular-search-sample.json`,
    null,
    fetchPop,
  );
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const { isEnabledConditionalRecaptcha, executeConditionalRecaptcha } = useConditionalRecaptcha();

  //json for filters
  const filterJsonData = [
    { name: 'APIs', options: null },
    { name: 'Solutions', options: null },
    { name: 'Support', options: null },
    {
      name: 'Categories',
      options: ['Authorization', 'Account Information', 'Payments', 'Cards'],
    },
  ];

  //callback after user starts typing
  const onsearchTermChange = (e, filterType) => {
    setsearchTerm(e.target.value);
    setFormError(false);
    setformErrorMessages([]);
    // clearhandler();
    if (e.target.value.length > 0) {
      setuserTyped(true);
    }
    // console.log(filterType);
  };
  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeConditionalRecaptcha) {
      setIsRecaptchaVerified(false);
      return;
    }
    const token = await executeConditionalRecaptcha('search_modal_form');
    return token;
    // setRecaptchaValue(token);
  }, [executeConditionalRecaptcha]);

  //form validations
  const validateForm = (formattedInputWithoutSpaces) => {
    let formErrors = [];
    //regex for script or tags
    const regexForTags = /<[^>]*>|script|javascript/gi;
    regexForTags.test(formattedInputWithoutSpaces) && formErrors.push('must not consist any tags');
    //Should contain atleast 1 letters
    formattedInputWithoutSpaces.length < 1 && formErrors.push('must be at least 1 characters long');
    // and no symbols allowed
    const alphaNumPattern = /^[a-zA-Z0-9 ]*$/;
    !alphaNumPattern.test(formattedInputWithoutSpaces) &&
      formErrors.push('must not have any symbols');

    if (formErrors.length > 0) setFormError(true);
    else setFormError(false);

    return formErrors;
  };

  //callback to handle submit(Enter Key) from Search UI Bar
  const handleSubmit = async (value, selectedFilterType) => {
    const trimmedValue = value.trim(); //replace spaces before and after value
    const validateFormErrorReturn = validateForm(trimmedValue);
    if (isEnabledConditionalRecaptcha ? isRecaptchaVerified : true) {
      if (validateFormErrorReturn && validateFormErrorReturn.length > 0) {
        setformErrorMessages(validateFormErrorReturn);
        return;
      } else {
        //form submission validated
        setloadingRes(true);
        setIsSubmitted(true);
        setshowPopSearch(false);
        setsubmittedTerm(trimmedValue);
        setResult([]);
        addToLocalStorage(trimmedValue, searchHistory);
        const results = await getUISearchResult(trimmedValue, selectedFilterType, {
          apisDataFromJson,
          faqsDataFromJson,
          solutionsDataFromJson,
          resourcessDataFromJson,
        });
        let resultCount = 0;
        if (results) {
          for (const key in results) {
            if (results[key] && results[key].total_items > 0) {
              resultCount = resultCount + results[key].total_items;
            }
          }
          if (resultCount > 0) {
            setloadingRes(false);
            setresultCount(resultCount);
            setResult(results);
          } else {
            setloadingRes(false);
            setresultCount(0);
            setResult([]);
          }
        } else {
          setloadingRes(false);
          setresultCount(0);
          setResult([]);
        }

        setIsRecaptchaVerified(false);
        return;
      }
    }
  };

  //callback to trigger on selecting recent search keywords
  const selectedRecentSearch = async (value) => {
    const trimmedValue = value.trim(); //replace spaces before and after value
    // const validateFormErrorReturn = validateForm(trimmedValue);
    setloadingRes(true);
    setIsSubmitted(true);
    setshowPopSearch(false);
    setsubmittedTerm(trimmedValue);
    setResult([]);
    setuserTyped(true); //consider as user typed or searched
    const results = await getUISearchResult(trimmedValue, null, {
      apisDataFromJson,
      faqsDataFromJson,
      solutionsDataFromJson,
      resourcessDataFromJson,
    });
    let resultCount = 0;
    if (results) {
      for (const key in results) {
        if (results[key].total_items > 0) {
          resultCount = resultCount + results[key].total_items;
        }
      }
      if (resultCount > 0) {
        setloadingRes(false);
        setresultCount(resultCount);
        setResult(results);
      } else {
        setloadingRes(false);
        setresultCount(0);
        setResult([]);
      }
    } else {
      setloadingRes(false);
      setresultCount(0);
      setResult([]);
    }
    return;

    // console.log(value);
  };

  useEffect(() => {
    setloadingRes(true);
    Session.getSessions('local', [{ key: 'all' }]).then((x) => {
      const val = x.find((item) => item.key === 'recent-searches');
      val && setsearchHistory(val['value']);
      val && setInitialRecentData(val['value']);
    });

    if (
      typeof getSearchPopularContent !== 'undefined' &&
      getSearchPopularContent?.type === 'success'
    ) {
      setPopularSearch(getSearchPopularContent?.response);
      setFetchPop(false);
    } else {
      setFetchPop(true);
    }

    setloadingRes(false);
    setLoading(false);
  }, [getSearchPopularContent]);

  //checks if recaptcha verified on user input
  useEffect(() => {
    const returnedValue = handleReCaptchaVerify();
    if (returnedValue) {
      // setRecaptchaValue(returnedValue);
      setIsRecaptchaVerified(true);
    }
  }, [handleReCaptchaVerify, searchTerm, selectedFilterValue]);

  //build the final result array
  useEffect(() => {
    setloadingRes(true);
    if (result) {
      const getSearchBuildResult = searchBuildResultArray(result);
      setRenderResult(getSearchBuildResult);
      // setloadingRes(false);
    } else {
      setRenderResult([]);
      // setloadingRes(false);
    }

    setTimeout(() => {
      setloadingRes(false);
    }, 100);
  }, [result]);

  return loading ? (
    <Loading />
  ) : (
    <>
      <SVBSearchModal show={show}>
        <div className='modal-header'>
          {title && <h5 className='modal-title'>{title}</h5>}
          <button
            type='button'
            className='close'
            data-dismiss='modal'
            aria-label='Close'
            onClick={hideSearchModal}
          >
            <img src={closeIcon} alt='close icon' role='close-dialog' width='20' height='20' />
          </button>
          <div className='container svb-container-fixed'>
            <SVBSearchUIBar
              onsearchTermChange={onsearchTermChange}
              handleSubmit={handleSubmit}
              filterType={selectedFilterValue}
              removeSelectedFilter={() => setselectedFilterValue('')}
              onClear={() => {
                setFormError(false);
                setformErrorMessages([]);
              }}
            />
            {formError && (
              <div className='pt-2 invalid-feedback d-block'>
                {'Search Input ' + formErrorMessages.join(' and ')}
              </div>
            )}
            {
              //once user starts typing show filter and hide explore and recentsearch comopnent
              userTyped ? (
                <SVBSearchFilter
                  getSelectedFilter={(value) => setselectedFilterValue(value)}
                  filterJsonData={filterJsonData}
                />
              ) : (
                <>
                  <SVBSearchExplore />
                  <SVBRecentSearch
                    recentSearchJson={initialRecentData}
                    removeRecentSearch={(key, val) =>
                      removeFromLocalStorage(key, val, searchHistory)
                    }
                    selectedRecentSearch={selectedRecentSearch}
                  />
                </>
              )
            }
          </div>
        </div>
        <div className='modal-body pt-0'>
          <div className='container svb-container-fixed'>
            <div className='row'>
              <div className=' col-sm-12 col-md-12 position-relative'>
                {isSubmitted ? (
                  //after user submission
                  <>
                    {loadingRes ? (
                      <Loading />
                    ) : resultCount > 0 && renderResult ? ( //if there is result count render the results
                      renderResult
                    ) : (
                      <SVBSearchEmptyResult searchParam={submittedTerm} />
                    )}
                  </>
                ) : (
                  <>
                    {/* Popular Search*/}
                    {showPopSearch && !loadingRes && popularSearch.length > 0 && (
                      <SVBSearchResult
                        categoryType='Popular Content'
                        cardJson={popularSearch}
                        resultLimit={3}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </SVBSearchModal>
    </>
  );
}

//callback after filter is selected from Search filter
// const getSelectedFilter = (value) => {
//     setselectedFilterValue(value);
// }
//callback after filter is removed from search UI bar
// const removeSelectedFilter = () => {
//     setselectedFilterValue('');
// }
//callback after clear is clicked
// const clearhandler = () => {
//     setFormError(false);
//     setformErrorMessages([]);
// }
